import * as React from 'react'
import { Text, Block } from '$views/components'
import { draft } from '$utils/services/formDraftService'
import { residenceFormDraftName, ResidenceFormSteps } from '$views/RecommendationsForms/ResidenceForm/ResidenceForm'
import { SummaryItem } from '$views/RecommendationsForms/ResidenceForm/SummaryStep/components/SummaryItem'
import { formatDateServiceViewMapper } from '$utils/dateFormatter'
import { Icon } from '$views/components/Icon'
import { Grid } from '$views/components/Grid'
import { ButtonForm } from '$views/RecommendationsForms/ResidenceForm/components/ButtonForm'
import { recommendationServices } from '$services/nursingHome'
import { ErrorView } from '$views/components/Error/Error.model'
import { Spinner } from '$views/components/Spinner'
import { formatError } from '$views/components/Error/Error.mapper'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { Error } from '$views/components/Error'

const calendarIcon = require('$icons/calendar.svg')
const locationIcon = require('$icons/location.svg')
const personIcon = require('$icons/person.svg')
const heartIcon = require('$icons/heart.svg')
const quotesIcon = require('$icons/quotes.svg')
const cleaness = require('$icons/cleaness.svg')
const companionship = require('$icons/companionship.svg')
const sanityAttention = require('$icons/sanityAttention.svg')
const transport = require('$icons/transport.svg')

interface Props {
  onPreviousStep: () => void
  onSelectedStep: (step) => void
  caretakerId?: string
}

export const SummaryStep: React.FC<Props> = ({ onPreviousStep, onSelectedStep, caretakerId }) => {
  const [isLoading, handleLoading] = React.useState<boolean>(false)
  const [errorNotification, setErrorNotification] = React.useState<ErrorView>()
  const [showErrorNotification, handleShowErrorNotification] = React.useState<boolean>(false)

  const locationFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.locationStep]
  const dateFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.dateStep]
  const residentFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.residentStep]
  const careFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.careStep] || ''

  const caresItems = (label, icon) => (
    <Block flex inline alignItems="center">
      <Icon content={icon} size="l" marginRight="base" />
      <Text marginTop="tiny">{label}</Text>
    </Block>
  )

  const showCares = () =>
    careFormData.companionship || careFormData.cleaness || careFormData.transport || careFormData.sanityAttention

  const getRowGap = () => {
    const cares = [
      careFormData.companionship,
      careFormData.cleaness,
      careFormData.transport,
      careFormData.sanityAttention,
    ]
    const selectedCares = cares.filter(care => care)
    return selectedCares.length > 2 ? 'mini' : 'none'
  }

  const onSubmit = async () => {
    handleLoading(true)
    try {
      await recommendationServices.createRecommendationService(caretakerId)
      history.push(routeProvider.residenceFormConfirmation)
      handleLoading(false)
    } catch (error) {
      const requestError = formatError(error)
      setErrorNotification(requestError)
      handleShowErrorNotification(true)
      handleLoading(false)
    }
  }

  return (
    <>
      {isLoading && <Spinner />}
      {showErrorNotification && <Error error={errorNotification} onClick={() => handleShowErrorNotification(false)} />}
      <Text title>Resumen de solicitud</Text>
      <Text marginTop="base">
        Revisa que los datos son correctos y edita lo que necesites. Te enviaremos los perfiles disponibles que mejor
        encajan
      </Text>
      <Block marginTop="medium">
        <SummaryItem icon={calendarIcon} onClick={() => onSelectedStep(ResidenceFormSteps.dateStep)}>
          <Block>
            {dateFormData.map(day => (
              <>
                {day.hours.map((hour, hourIndex) => (
                  <div key={hourIndex}>
                    <Text as="span" weight="medium" marginRight="mini">
                      {formatDateServiceViewMapper(day.date)}
                    </Text>
                    <Text as="span">{`${hour.start}h · `}</Text>
                    <Text as="span">{`${hour.duration} horas`}</Text>
                  </div>
                ))}
              </>
            ))}
          </Block>
        </SummaryItem>
        <SummaryItem icon={locationIcon} onClick={() => onSelectedStep(ResidenceFormSteps.locationStep)}>
          <Text>{locationFormData.address}</Text>
        </SummaryItem>
        <SummaryItem icon={personIcon} onClick={() => onSelectedStep(ResidenceFormSteps.residentStep)}>
          <Text as="span" weight="medium" marginRight="base">
            Residente
          </Text>
          <Text>{residentFormData.name}</Text>
        </SummaryItem>
        {showCares() && (
          <SummaryItem icon={heartIcon} onClick={() => onSelectedStep(ResidenceFormSteps.careStep)}>
            <Grid columns={2} rows={2} columnGap="mini" rowGap={getRowGap()}>
              {careFormData.companionship && caresItems('Compañia', companionship)}
              {careFormData.cleaness && caresItems('Aseo', cleaness)}
              {careFormData.transport && caresItems('Transporte', transport)}
              {careFormData.sanityAttention && caresItems('Atención sanitaria', sanityAttention)}
            </Grid>
          </SummaryItem>
        )}
        {careFormData.extraInformation && (
          <SummaryItem icon={quotesIcon} onClick={() => onSelectedStep(ResidenceFormSteps.careStep)}>
            {careFormData.extraInformation}
          </SummaryItem>
        )}
      </Block>
      <Block marginTop="small" marginBottom="medium">
        <ButtonForm nextButtonLabel="Enviar solicitud" onNextStep={onSubmit} onPreviousStep={onPreviousStep} />
      </Block>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/SummaryStep/SummaryStep.tsx